export type EntryFields = Readonly<{
  showAmount: boolean;
  showMethodAndDate: boolean;
  showDebitCredit: boolean;
  showActions: boolean;
  canEditAmount: boolean;
}>;

// Which fields an entry shows per tab. Mirrors the column visibility of the desktop table:
// ledger (several kinds) swaps amount and actions for debit/credit; proceeds keeps only
// the description and an editable amount.
export const getEntryFields = (kindEntry: readonly string[]): EntryFields => {
  const isLedger = kindEntry.length > 1;
  const isProceeds = kindEntry.includes('proceeds');

  return {
    showAmount: !isLedger,
    showMethodAndDate: !isProceeds,
    showDebitCredit: isLedger,
    showActions: !isLedger && !isProceeds,
    canEditAmount: isProceeds,
  };
};
